





























import { Component, Vue } from "vue-property-decorator";
import TaskList from "../components/TaskList.vue";
import TaskListItem from "../components/TaskListItem.vue";
import Task from "../models/task";

import { client } from "@/api/request";
import TaskApi from "../../api/task-api";
import TaskService from "../../usecases/task-service";
import Subtask from "@/api/project/subtask";
import SubtaskApi from "../../../api/project/subtask-api";
import AppHeader from "../../../views/AppHeader.vue";

const service = new TaskService(new TaskApi(client));

@Component({
  components: {
    AppHeader,
    TaskList,
    TaskListItem
  }
})
export default class UserTaskList extends Vue {
  tasks: Task[] = [];
  hiddenDoneTasks = true;
  orderBy = "";
  orderOptions = [
    {
      text: "作成順",
      value: ""
    },
    {
      text: "日程順",
      value: "duedate"
    },
    {
      text: "現場順",
      value: "project"
    }
  ];

  /**
   * 完了・未完了を切り替える
   */
  async toggle(task: Task, done: boolean) {
    const subtask = new Subtask(Number(task.id), task.name, done, task.dueDate);
    const api = new SubtaskApi(client);
    await api.save(subtask);
    // 先にタスク取得が動いてしまうので遅らせる
    setTimeout(() => {
      this.loadTasks();
    }, 100);
  }

  toggleDisplayMode() {
    this.hiddenDoneTasks = !this.hiddenDoneTasks;
    this.loadTasks();
  }

  get btnLabel() {
    if (this.hiddenDoneTasks) {
      return "完了したタスクを表示する";
    }
    return "完了したタスクを非表示にする";
  }

  protected async created() {
    this.loadTasks();
  }

  private async loadTasks() {
    this.tasks = (await service.search(
      new Date(),
      this.hiddenDoneTasks,
      this.orderBy
    )).map(t => ({
      ...t,
      dueDateVariant: t.overdue ? "danger" : ""
    }));
  }
}
